"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualModuleConfigurationType = void 0;
exports.generateDnpConfiguration = generateDnpConfiguration;
var VirtualModuleConfigurationType;
(function (VirtualModuleConfigurationType) {
    VirtualModuleConfigurationType["ElectricalOverride"] = "electricalOverride";
    VirtualModuleConfigurationType["CustomComponent"] = "customComponent";
})(VirtualModuleConfigurationType || (exports.VirtualModuleConfigurationType = VirtualModuleConfigurationType = {}));
function generateDnpConfiguration(project) {
    const designConfig = {
        modules: {},
    };
    for (const module of project.modules) {
        if (module.isDnp) {
            designConfig.modules[module.name] = {
                name: module.name,
                isDnp: true,
            };
        }
    }
    return designConfig;
}
//# sourceMappingURL=DesignConfiguration.js.map